var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseProvider } from "./base.provider";
import { injectScript } from "../utilities/dom-mutations";
export class EvolutionProvider extends BaseProvider {
    iframeResizer() {
        const rect = document.getElementById("evolutionIframe");
        const heights = rect.offsetTop; // TODO: iFrameResizer.calculateBarHeights()
        const width = rect.offsetLeft; // TODO: iFrameResizer.calculateSideBarWidth()
        if (!window.EvolutionGaming)
            return; // Evolution has not been initialized yet
        window.EvolutionGaming.init({
            iframeId: "lobby_game",
            topBar: heights,
            sideBarLandscape: width,
        });
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const scripts = [
                {
                    url: "https://studio.evolutiongaming.com/frontend/evo/r2/js/iframe.js", // TODO: Fetch this from API
                },
            ];
            const mappedScripts = scripts.map((s, index) => {
                return {
                    hid: `evolutionexternalscript-${index}`,
                    src: s.url,
                    callback: () => this.iframeResizer(),
                };
            });
            injectScript(mappedScripts);
        });
    }
}
